import { clearRecaptchaToken, setRecaptchaToken } from '@src/actions/recaptcha.actions';
import { configPublic } from '@src/config.public';
import { log } from '@src/utils/log.util';
import { instrumentAction } from "@src/utils/instrumentation";
const getRecaptchaToken = async (action: string) => {
  return await new Promise(async resolve => {
    await instrumentAction("RecaptchaActions.clearRecaptchaToken", clearRecaptchaToken)();
    const grecaptcha = typeof window !== 'undefined' ? (window as any)?.grecaptcha : undefined;
    if (!grecaptcha) {
      log.error('The Recaptcha SDK (window.grecaptcha) was not found.');
      resolve(undefined);
    }
    grecaptcha.ready(async () => {
      try {
        const token = await grecaptcha.execute(configPublic.googleRecaptcha.siteKey, {
          action
        });
        log.debug('[Recaptcha] token received', {
          token
        });
        await instrumentAction("RecaptchaActions.setRecaptchaToken", setRecaptchaToken)(token);
        resolve(token);
      } catch (error: any) {
        log.error(`[Recaptcha] Error getting token - ${error?.message}`, error);
        resolve(undefined);
      }
    });
  });
};
export const useRecaptchaV3 = () => {
  return {
    getRecaptchaToken
  };
};